import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Activity18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.72357 3.80266L9.07181 12.4129L11.2885 5.76283C11.4953 5.1423 12.3783 5.07955 12.6708 5.66459L14.3944 9.1118C14.4368 9.1965 14.5233 9.25 14.618 9.25H18V10.75H14.618C13.9552 10.75 13.3492 10.3755 13.0528 9.78262L12.1389 7.95491L9.71151 15.2372C9.48235 15.9247 8.4671 15.8965 8.27643 15.1973L5.92819 6.58714L4.93944 9.5534C4.70124 10.268 4.03249 10.75 3.27924 10.75H0V9.25H3.27924C3.38685 9.25 3.48238 9.18114 3.51641 9.07906L5.28849 3.76283C5.51765 3.07535 6.5329 3.10353 6.72357 3.80266Z'
      fill='currentColor'
    />
  </Svg>
);

Activity18.displayName = 'Activity18';
export default Activity18;
